/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsDraftRankCostsDefaultsQueryResponse,
  GetTournamentsDraftRankCostsDefaults500,
} from "../types/GetTournamentsDraftRankCostsDefaults.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsDraftRankCostsDefaultsQueryKey = () =>
  [{ url: "/tournaments/draft/rank-costs/defaults" }] as const;

export type GetTournamentsDraftRankCostsDefaultsQueryKey = ReturnType<
  typeof getTournamentsDraftRankCostsDefaultsQueryKey
>;

/**
 * {@link /tournaments/draft/rank-costs/defaults}
 */
export async function getTournamentsDraftRankCostsDefaults(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsDraftRankCostsDefaultsQueryResponse,
    ResponseErrorConfig<GetTournamentsDraftRankCostsDefaults500>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/draft/rank-costs/defaults`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsDraftRankCostsDefaultsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsDraftRankCostsDefaultsQueryKey();
  return queryOptions<
    ResponseConfig<GetTournamentsDraftRankCostsDefaultsQueryResponse>,
    ResponseErrorConfig<GetTournamentsDraftRankCostsDefaults500>,
    ResponseConfig<GetTournamentsDraftRankCostsDefaultsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsDraftRankCostsDefaults({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * {@link /tournaments/draft/rank-costs/defaults}
 */
export function useGetTournamentsDraftRankCostsDefaults<
  TData = ResponseConfig<GetTournamentsDraftRankCostsDefaultsQueryResponse>,
  TQueryData =
    ResponseConfig<GetTournamentsDraftRankCostsDefaultsQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsDraftRankCostsDefaultsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsDraftRankCostsDefaultsQueryResponse>,
        ResponseErrorConfig<GetTournamentsDraftRankCostsDefaults500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTournamentsDraftRankCostsDefaultsQueryKey();

  const query = useQuery(
    {
      ...getTournamentsDraftRankCostsDefaultsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTournamentsDraftRankCostsDefaults500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
